import { Info } from '@phosphor-icons/react'

export default function FilterUbiquaNotice({ children }) {
  return (
    <span className="filter-ubiqua-mui-notice">
      <Info size={14} aria-hidden="true" />
      {children}
    </span>
  )
}
